import {
    Row, Col, Tabs, Typography, ConfigProvider, List,  Popover
} from 'antd';
import {
    ToolOutlined, WarningOutlined, BellOutlined, EyeOutlined, InfoCircleOutlined
} from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import PanelFrame from "../../components/panels/PanelFrame";
import {useScreenSizeBelow} from "../../utility/hooks/useScreenSize";
import './Maintenance.css';
import { getSessionData } from '../../utility/global-util';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";


export const ViewTestHint = ({message, placement, isEligibleForTest}) => {
  const content = (
    <div>
      <p>{ message }</p>
    </div>);

  return (
    <Popover content={content}
             trigger="click"
             placement={placement}
    >
      <table>
        <tbody>
          <tr>
            <td>
            {
              !isEligibleForTest
              ?
              <InfoCircleOutlined style={{ marginLeft: '5px', fontSize: '20px'}}/>
              :
              <></>
            }
            </td>
          </tr>
        </tbody>
      </table>
    </Popover>
  )
}

export const ViewNextServiceDetail = ({nextService}) => {
  const { t } = useTranslation();
  const contractVehicle  = getSessionData('currentContract')?.contractVehicle
  const { Text } = Typography;
  let showTimeAndDistanceMessage = nextService != null && nextService.dueDate != null && nextService.odometerReading != null;
  let showTimeOnlyMessage = nextService != null && nextService.dueDate != null && nextService.odometerReading == null;
  const uom = (contractVehicle.odoUom  === "MILE" &&  (" " + t("bynxuom.mile"))) || (contractVehicle.odoUom === "KM" && (" " + t("bynxuom.km"))) || '';

  return (
          <table style={{marginBottom:"15px"}}>
            <tbody>
              <tr>
                  <td> <ToolOutlined style={{fontSize:"20px", marginRight:"true"}}/></td>
                  <td>
                    {
                      (nextService === null || nextService === undefined)
                      ?
                      <Text > { t('message.next_service_unknown') } </Text>
                      :
                      (nextService != null && showTimeAndDistanceMessage)
                      ?
                      <Text> {t('message.next_service_time_distance', {0: nextService.description, 1: nextService.odometerReading + uom, 2: ''})}
                        <span style={{textWrap: 'nowrap' }}> {nextService.dueDate} </span>
                      </Text>
                      :
                      (nextService != null && showTimeOnlyMessage)
                      ?
                      <Text> {t('message.next_service_time_only', {0: nextService.description, 1: ''})}
                        <span style={{textWrap: 'nowrap' }}> {nextService.dueDate} </span>
                      </Text>
                      :
                      <></>
                    }
                  </td>
              </tr>
            </tbody>
          </table>
         )
}


const SummaryTabbedCanvas = ({isEligibleForRecall, setMainTab, viewRecallsButton, nextService, viewPendingReviewJobDetails, maintenanceServices, maintenanceRecalls, lastJob, jobsAwaitingReview, permissions, setHistoryItem}) => {
  const { t } = useTranslation();
  const { Text } = Typography;
  const [currentContractNo, setCurrentContractNo] = useState(null);
  const [controlTab, setControlTab] = useState('overview');

  const ViewLastJobDetail = ({lastJob}) => {
    return (
            <div>
              <Row>
                <Text>{t('message.last_maintenance', {0: lastJob.arrivalDate, 1: lastJob.supplier})}</Text>
              </Row>
            </div>
           )
  }

  const ViewRecallMessage = ({isEligibleForRecall, recalls, openRecallPopup}) => {
    return (
             (isEligibleForRecall)
             ?
             <Row style={{width:'100%'}} align="middle" justify="space-between">
                <Col className="maint-summary-list-left-column">
                  <WarningOutlined className="maint-summary-list-icon"/>
                  <Text className="maint-summary-list-text">{ t('message.outstanding_recalls', {0: recalls?.length}) }</Text>
                </Col>
                <Col>
                   <EyeOutlined className="maint-summary-list-right-column" onClick={(e) => openRecallPopup(e)}/>
                </Col>
             </Row>
             :
             <></> 
           )
  }

  const JobAwaitingReview = ({jobsAwaitingReview, openReviewPopup, permissions}) => {
    const { isOnline } = useOnlineStatus();
    return (
             (permissions.includes("DRIVERS_PORTAL_MAINTENANCE_APPROVAL") && jobsAwaitingReview?.length > 0 )
             ?
             <List  className="maint-panel-list">
                {jobsAwaitingReview.map(jobAwaitingReview => (
                    <List.Item key={jobAwaitingReview.id}>
                        <Row style={{width:'100%'}} align="middle" justify="space-between"> 
                            <Col className="maint-summary-list-left-column">
                              <BellOutlined className="maint-summary-list-icon" style={{ color: 'red' }}/>
                              <Text className="maint-summary-list-text">{ t('message.job_requires_review', {0: jobAwaitingReview?.reference}) }</Text>
                            </Col>
                            <Col>
                                {isOnline
                                 ? <EyeOutlined className="maint-summary-list-right-column" onClick={(e) => openReviewPopup(e, jobAwaitingReview)}/>
                                 : <></>}
                            </Col>
                        </Row>
                    </List.Item>
                ))}
            </List>    
            :
            <></> 
          )
  }

  const SummaryDetails = ({isEligibleForRecall, recalls, openRecallPopup, nextService, pendingReviews, openReviewPopup, permissions}) => {
    let displayHeight=110;

    if (useScreenSizeBelow(768)) {  //same as similar code in PanelFrameWithImage and matching image control in dp-panel-frame-image
        displayHeight = null;
    }

    return (
             <div style={{height: displayHeight, overflow:'auto'}}>
                <Row>
                    <JobAwaitingReview jobsAwaitingReview={pendingReviews} openReviewPopup={openReviewPopup} permissions={permissions}> </JobAwaitingReview>
                    <ViewRecallMessage isEligibleForRecall={isEligibleForRecall} recalls={recalls} openRecallPopup={openRecallPopup}></ViewRecallMessage>
                    <ViewNextServiceDetail nextService={nextService}></ViewNextServiceDetail>
                </Row>            
             </div>
           )
  }

  // Tab Structure
  const SummaryTab = ({isEligibleForRecall, recalls, openRecallPopup, nextService, pendingReviews, openReviewPopup, permissions}) => {
    return (
             <div>
                <PanelFrame title=''
                            tabMode={true} 
                            backgroundType="default"
                >
                    <Row>
                        <SummaryDetails isEligibleForRecall={isEligibleForRecall}
                                         recalls={recalls}
                                         openRecallPopup={openRecallPopup}
                                         nextService={nextService}
                                         pendingReviews={pendingReviews}
                                         openReviewPopup={openReviewPopup}
                                         permissions={permissions}
                        >
                        </SummaryDetails>
                    </Row>  
                </PanelFrame>
            </div>
          )
  }
  
  const ServicesTab = ({nextService}) => {
    return (
             <div>
                <PanelFrame tabMode={true} borderRadius={'5px'} >
                    <Row style={{width:'100%'}} align="left">
                        <ViewNextServiceDetail nextService={nextService}/>
                    </Row >
                </PanelFrame>       
            </div>
           )
  }
  
  const HistoryTab = ({lastJob, setHistoryItem}) => {
    return (
             <div>
                <PanelFrame tabMode={true} borderRadius={'5px'} >
                    <Row style={{width:'100%'}} align="middle">
                      <Col span={21}>
                        <ViewLastJobDetail lastJob={lastJob}/>
                      </Col>
                      <Col span={3}>
                        <EyeOutlined style={{ marginRight: '10px', fontSize: '20px', float: 'right' }} onClick={(e) => setHistoryItem(lastJob)}/>
                      </Col>
                    </Row >
                </PanelFrame>       
            </div>
           )
  }

  const deriveSummaryTabs = (services, recalls, lastJob, pendingReviews, permissions) => {
    let requestBookingTabs = [{
                                key: 'overview',
                                label: t('field.summary'),
                                children: <SummaryTab isEligibleForRecall={isEligibleForRecall} 
                                                       recalls={recalls} 
                                                       openRecallPopup={viewRecallsButton} 
                                                       nextService={nextService} 
                                                       pendingReviews={pendingReviews}
                                                       openReviewPopup={viewPendingReviewJobDetails} 
                                                       permissions={permissions}/>,
                             }];
    let service = [{
                    key: 'services',
                    label: t('title.service_schedule'),
                    children: <ServicesTab nextService={nextService}/>,
                  }];

    let history = [{
                    key: 'history',
                    label: t('title.history'),
                    children: <HistoryTab lastJob={lastJob}
                                          setHistoryItem={setHistoryItem}/>,
                  }];

    if (services !== null && services.length > 0)
    {
      requestBookingTabs = requestBookingTabs.concat(service);
    }

    if (lastJob)
    {
      requestBookingTabs = requestBookingTabs.concat(history);
    }

    return requestBookingTabs;
  }

  const currentContract = getSessionData('currentContract');
  useEffect(() => {
      if (currentContract && ( currentContractNo == null || currentContract.contractNo !== currentContractNo )) {
          setCurrentContractNo(currentContract.contractNo);
          setControlTab('overview');  //Sets tab back to summary when the vehicle is changed
          setMainTab('overview');  //Also resets the buttons
      }
  }, [currentContract, currentContractNo, setMainTab]);

  return (
        <ConfigProvider
          theme={{
            components: {
                Tabs: {
                    /* design tokens */
                    horizontalItemGutter: 10,
                    horizontalMargin: '-15px 0px -15px 0'
                    },
            },
          }}  //ant-tabs-nav
        >
            <Tabs activeKey={controlTab}
                  style={{ width: '100%', minHeight: '100px', marginBottom: 2,}}
                  type="line"
                  size="medium"
                  onChange={ (key) => {
                      setControlTab(key); //tab
                      setMainTab(key); //buttons
                  }}
                  items={deriveSummaryTabs(maintenanceServices, maintenanceRecalls, lastJob, jobsAwaitingReview, permissions)} 
            />
        </ConfigProvider>
  );
}

export default SummaryTabbedCanvas;